<template>
  <div>
    <form class="credit-card" id="adyen-encrypted-form">
      <div class="row">
        <div class="col-xs-12">
          <div class="form-box margin-b20">
            <b class="title-identification margin-b10">Informações do Cartão de Crédito dasdasds</b>
            <div class="form-content">
              <p class="no-margin" v-if="checkPromoSenff || creditCard.paymentMethodId == 22">
                Para sua segurança, esta venda é permitida apenas com o Cartão Virtual.
                <br>
                Acesse o App ou site Senff para gerá-lo e em caso de dúvidas,
                <a class="link-senff" target="_blank" href="https://www.senff.com.br/cartao-virtual-senff/">clique aqui.</a>
              </p>
            <div class="form-group margin-t20">
              <div class="cc-box">
                <label class="bold"  for="brand">Bandeira:</label>
                <div class="radio inline" @click="select('visa')" v-if="!checkPromoSenff && showBandeira('Visa')">
                  <label>
                    <input type="radio" name="optradio">
                    <img class="credit-card-selection visa" src='/static/payment-methods/visa.svg' width="31" height="28" v-bind:class="{ selected: creditCard.paymentMethodId==6}">
                  </label>
                </div>
                <div class="radio inline" @click="select('master')" v-if="!checkPromoSenff && showBandeira('Mastercard')">
                  <label>
                    <input type="radio" name="optradio">
                    <img class="credit-card-selection master" src='/static/payment-methods/master.svg' width="31" height="28" v-bind:class="{ selected: creditCard.paymentMethodId==7}">
                  </label>
                </div>
                <div class="radio inline" @click="select('elo')" v-if="showElo && !checkPromoSenff && showBandeira('Elo')">
                  <label>
                    <input type="radio" name="optradio">
                    <img class="credit-card-selection elo" src='/static/payment-methods/elo.svg' width="31" height="28" v-bind:class="{ selected: creditCard.paymentMethodId==10}">
                  </label>
                </div>

                <input type="text" name="brand" id="brand" v-model="brand" v-validate="'required'" style="display:none;" >
                <!-- <img class="credit-card-selection amex" @click="select('amex')" src='/static/payment-methods/amex.svg' width="31" height="28"v-bind:class="{ selected: creditCard.paymentMethodId==8}"> -->
              </div>
              <p class="info-card no-margin line-height-20">Selecione uma Bandeira.</p>
              <div id="msg-error-brand" class="msg-error-brand" style="display: none">
                Por favor, selecione uma bandeira.
              </div>
            </div>
            <div class="form-group margin-t20" :class="{'has-error': errors.has('number')}">
              <div class="cc-box">
                <label class="bold" for="">Número do cartão:</label>
                <input class="form-control number inline" name="number" type="text" v-model.lazy="creditCard.number" v-validate="'required'"  data-vv-validate-on="blur" v-mask-card  data-encrypted-name="number" v-on:blur="errorBrand()">
              </div>
              <p class="info-card no-margin line-height-20">Insira os números sem espaços ou sinais.</p>
              <div class="help-block cc">
                {{ errors.first('number') }}
              </div>
            </div>
            <div class="form-group" :class="{'has-error': errors.has('expire')}">
              <label class="bold" for="" style="display: block">Validade:</label>

              <div>
                <div class="width100 inline">
                  <label class="bold" for="">Mês:</label>
                  <input class="form-control block" name="expire" type="text" v-model="creditCard.expirationMonth" data-encrypted-name="expiryMonth" minlength="2" maxlength="2" v-validate="'required|min:2|max_value:12|min_value:1'" placeholder="12">
                </div>
                <div class="width100 inline">
                  <label class="bold" for="">Ano:</label>
                  <input class="form-control block" name="expire" type="text" v-model="creditCard.expirationYear" data-encrypted-name="expiryYear" minlength="4" maxlength="4" v-validate="'required|min:4|min_value:'+thisYear" placeholder="2030">
                </div>
              </div>

            </div>

            <div class="form-group help margin-b20" style="display: inline-block" :class="{'has-error': errors.has('ownerName')}">
              <label class="bold" for="">Nome do titular do Cartão de Crédito:</label>
              <input class="form-control name" type="text" v-model="creditCard.ownerName" v-validate="'required'" maxlength="80" data-encrypted-name="holderName" name="ownerName">
              <div class="help-block">
                {{ errors.first('ownerName') }}
              </div>
            </div>

            <div class="form-group help right margin-b20" style="display: inline-block" :class="{'has-error': errors.has('cvv')}" v-if="showCvv">
              <label class="label-csc" for="">Código de Segurança:</label>
              <input class="form-control csc" type="text" v-model="creditCard.cvv" name="cvv" v-validate="'required|min:3'" maxlength="4" v-only-numbers data-encrypted-name="cvc">
              <img src="../../../assets/img/img-card-security-code.png" alt="">
              <div class="help-block">
                {{ errors.first('cvv') }}
              </div>
            </div>

            <!-- Atencao, componente compartilhado -->
              <div class="row">
                <div class="col-xs-12">
                  <p><br>O endereço abaixo <b>NÃO</b> é o de entrega de TAGs</p>
                  <div class="form-box">
                    <address-comp ref="addressBilling" :address="address" type="BILLING"></address-comp>
                  </div>
                </div>
              </div>

            <input type="hidden" :value="dateTime" data-encrypted-name="generationtime"/>
            <input type="submit" value="Pay" id="adyenSubmit" style="display:none"/>
          </div>
        </div>
      </div>
    </div>
  </form>

  </div>
</template>
<style scoped lang="scss">
  .link-senff {
    color: #0074C8;
    text-decoration: underline;
  }
  .form-group.right {
    margin-left: 20px;
  }
  .block {
    display: block !important;
  }
  .width100 {
    width: 100px;
  }
  .form-control {
    &.number, &.name, &.csc, &.block {
      height: 40px;
    }
    &.number {
      width: 170px;
    }
    &.name {
      /*width: 250px;*/
      width: 100%;
    }
    &.csc {
      width: 75px;
      display: inline-block;
    }
    &.month, &.year {
      display: inline;
    }
  }
  .label-csc {
    font-weight: bold;
    display: block;
  }
  .dropdown-payment {
    &.month,
    &.month .dropdown-menu.option {
      width: 75px;
    }
    &.year,
    &.year .dropdown-menu.option {
      width: 90px;
    }
  }
  .help .help-block {
    position: absolute;
  }
  .dropdown-payment.block {
    display: block;
  }
  .cc-box {
    label {
      display: block;
    }
    .credit-card {
      margin-left: 10px;
    }
  }
  .help-block.cc {
    margin-top: -2px;
  }
  input.invalid {
    border-color: #FC4513;
  }
  .radio.inline {
    margin-right: 5px;
    margin-top: 0px;
    label {
      padding-left: 0px;
    }
    input {
      position: relative;
      margin-left: 10px;
      margin-bottom: 3px;
    }
    img {
      width: 35px;
    }
  }
  .credit-card-selection{
    -webkit-filter: grayscale(80%); /* Safari 6.0 - 9.0 */
    filter: grayscale(80%);
    display: block;
  }

  .credit-card-selection:hover{
    filter: grayscale(0%);
  }

  .selected{
    filter: grayscale(0%);
  }
  .msg-error-brand {
    color: #a94442;
    font-size: 0.8em;
    margin: 0;
  }
</style>
<script>
  import addressComp from '../../common/address.vue'
  import * as objectsStructure from '../../common/adhesion/objects'
  import { validateCreditCard } from '../../../utils'
  import MessageDialog from '../../../components/message-dialog'
  import * as Utils from '../../../utils'
  import {EventBus} from '../../../event-bus'
  import Financial from '../../../services/financial'

  export default {
    props: ['showCvv', 'options', 'valueStart', 'addressStart', 'planId'],
    data(){
      return {
        address: objectsStructure.address(),
        creditCard: {ownerName: "", number:"", expirationMonth:"", expirationYear: "", cvv:"", brand:"", paymentMethodId: ""},
        months: [],
        years: [],
        itemSelected: undefined,
        dateTime: undefined,
        brand: undefined,
        thisYear: undefined,
        ops: undefined,
        metodosDePagamento: []
      }
    },
    watch:{
      brand(newVal){
        let opt = _.find(this.options, (o) => {
          return o.name == newVal;
        });
        this.emitCreditCard();
        this.errorBrand();
      }
    },
    created: function(){


      if(this.addressStart){
        this.address = JSON.parse(JSON.stringify(this.addressStart));
        this.address.addressId = undefined;
      }


      if(this.valueStart){
        this.itemSelected = this.creditCard = this.valueStart;
        this.emitCreditCard();
      }


      for(let i=1; i<13; i++){
        this.months.push({value: i, caption: i});
      }
      let currentYear = parseInt(new Date().getFullYear());
      for(let i=currentYear; i<currentYear + 30; i++){
        this.years.push({value: i, caption: i});
      }

      this.ops = this.getMeiosDePagamento();
    },
    computed:{
      selectOption(){
        if(this.creditCard && this.creditCard.paymentMethodId)
          return this.creditCard.paymentMethodId;

        return this.options[0].paymentMethodId;
      },
      showElo(){
        let p = this.$store.getters.getAllPayments;
        if(p){
          return p["Elo"]
        };
        return false;
      },
      checkPromoSenff() {
        if (sessionStorage.getItem('promoCheck') == '#SENFF2020')
          return true;
      },

    },

    mounted(){
      this.thisYear = new Date().getFullYear();
    },
    methods:{

      async getMeiosDePagamento() {
      const meios = await Financial.getMeiosDePagamentoAdesao(this.planId);
      const Arr = meios.data.list;

      this.metodosDePagamento = meios.data.list;
    },
      errorBrand() {
        if(this.brand == '' || this.brand == undefined) {
          document.getElementById('msg-error-brand').style.display='block';
        } else {
          document.getElementById('msg-error-brand').style.display='none';
        }
      },
      select(brand){
        switch(brand){
        case "visa":
            this.creditCard.paymentMethodId = 6;
            this.brand = "Visa";
            this.itemSelected = {
              active:"1",
              caption:"Visa",
              imagePath:"visa.svg",
              name:"Visa",
              paymentMethodId:6,
              type:"CC",
              value:6
            }
            break;
        case "master":
            this.creditCard.paymentMethodId = 7;
            this.brand = "Mastercard";
            this.itemSelected = {
              active:"1",
              caption:"Mastercard",
              imagePath:"master.svg",
              name:"Mastercard",
              paymentMethodId:7,
              type:"CC",
              value:7,
            }
            break;
        case 'amex':
            this.creditCard.paymentMethodId = 8;
            this.brand = "American Express"
            this.itemSelected = {
              active:"1",
              caption:"American Express",
              imagePath:"amex.svg",
              name:"American Express",
              paymentMethodId:8,
              type:"CC",
              value:8,
            }
            break;
        case 'elo':
            this.creditCard.paymentMethodId = 10;
            this.brand = "Elo";
            this.itemSelected = {
              active:"1",
              caption:"Elo",
              imagePath:"elo.svg",
              name:"Elo",
              paymentMethodId:10,
              type:"CC",
              value:10,
            }
            break;
        case 'Hipercard':
            this.creditCard.paymentMethodId = 11;
            this.brand = "HiperCard"
            this.itemSelected = {
              active:"1",
              caption:"HiperCard",
              imagePath:"Hipercard.svg",
              name:"HiperCard",
              paymentMethodId:11,
              type:"CC",
              value:11,
            }
            break;
        case 'Senff':
          this.creditCard.paymentMethodId = 22;
            this.brand = "Senff"
            this.itemSelected = {
              active:"1",
              caption:"Senff",
              imagePath:"senff.svg",
              name:"Senff",
              paymentMethodId:22,
              type:"CC",
              value:22,
            }
            break;
    }
      },

      getPayment(){
        let vm = this;

        let p = this.creditCard;
        return this.$validator.validateAll()
        .then((success) => {
          return vm.$refs.addressBilling.$validator.validateAll().then(s => {
            p.paymentMethod = {paymentMethodId: p.paymentMethodId};
            p.billingAddress = this.address;
            EventBus.$emit('setPayment', p);
            return p;

          });
        });
      },
      onItemSelected(item){
        this.itemSelected = item;
        this.emitCreditCard();
      },
      emitCreditCard(){
        let vm = this;
        if(vm.itemSelected){
          vm.creditCard.paymentMethodId = vm.itemSelected.paymentMethodId;
          vm.creditCard.imagePath = vm.itemSelected.imagePath;
          vm.creditCard.validForm = true;
          vm.creditCard.billingAddress = vm.address;
          vm.creditCard.brand = vm.itemSelected.name;
        }
        vm.$emit('input', vm.creditCard);
      },
      validateAll(){
        let vm = this;

          if(!validateCreditCard(this.creditCard.expirationMonth, this.creditCard.expirationYear)){
           MessageDialog.show({
              title: 'Info',
              message:  'Data de validade do cartão inválida.'
            });

            return false;
          }

        return this.$validator.validateAll()
          .then( r => {
            return r;
          }).then( r => {
              return vm.$refs.addressBilling.$validator.validateAll();
          });
      },
      getCardBrand(value, value2, value3){
        this.brand = Utils.getCardBrand(value.currentTarget.value);
      },
      imageUrl(){
        if(this.creditCard && this.creditCard.imagePath)
          return '/static/payment-methods/' + this.creditCard.imagePath.split('.')[0] + '.svg';
          return "";
      },
      showBandeira(band) {
      const paymentMapping = {
        'Visa': 6,
        'Mastercard': 7,
        'Elo': 10,
        'HiperCard': 11
      };
      const requiredPaymentMethodId = paymentMapping[band];

      if (!this.metodosDePagamento || !this.metodosDePagamento.length) return false;

      return this.metodosDePagamento.some(pm =>
        pm.paymentMethodId === requiredPaymentMethodId && pm.displaySite === 'Y'
      );
    },


    },
    components: {
      addressComp
    }
  }
</script>



// WEBPACK FOOTER //
// credit-card.vue?61d19f24